import type { SlateBlock } from '@atlas/renderer';
import isMultiLineTextBlock, { type MultiLineTextBlock } from '@atlas/tool/box/slate/isMultiLineTextBlock';
import isOneLineTextBlock, { type OneLineTextBlock } from '@atlas/tool/box/slate/isOneLineTextBlock';

export default function isTextBlock(block: SlateBlock): block is TextBlock {
    return isOneLineTextBlock(block) || isMultiLineTextBlock(block);
}

// #region Types

export type TextBlock = OneLineTextBlock | MultiLineTextBlock;

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isTextBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
